/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import IconDinero from '../../../Icons/IconDinero';
import IconPorcentaje from '../../../Icons/IconPorcentaje';
import IconTarjeta from '../../../Icons/IconTarjeta';
import { useAuthStore } from '../../../store/AuthContext';
import { useAppStore } from '../../../store/AppContext';
import { TarjetasHelper } from '../TarjetasHelper';
import { TarjetaService } from '../../../services';
import { GtmManager } from '../../../utils/GtmManager';
import useAPIError from '../../../hooks/useAPIError';

const SolicitarInformacionTPEC: FC = () => {
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const { addError } = useAPIError();
  if (dataUser.user.isGibraltar || dataUser.user.isEmpresa) {
    return <></>;
  } else {
    const dataApp = useAppStore();
    const [tarjetaPathLang, setTarjetaPathLang] = useState<string>(
      TarjetasHelper.getCorrectDataLang(dataApp),
    );
    const solicitarTarjetaPago = () => {
      const url = `https://altatarjetadecredito.eroski.es/sociost/${tarjetaPathLang}/`;
      const to_request = t('tarjetas.tarjeta-socio.to-request');
      const clic_button = t('tarjetas.tarjeta-socio.save-with-credit-card');
      TarjetaService.solicitarTarjPago()
        .then((response) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          response.data.click_name = to_request;
          response.data.click_title = clic_button;
          GtmManager.sendAComportamientoEvent(response.data);
          window.open(url);
        })
        .catch(() => {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'ERROR');
        });
    };
    useEffect(() => {
      const languaje = dataApp.lang;
      if (languaje !== i18n.language) {
        if (languaje === 'eu') {
          setTarjetaPathLang('eu-ES');
        }
        if (languaje === 'ca') {
          setTarjetaPathLang('ca-ES');
        }
        if (languaje === 'gl') {
          setTarjetaPathLang('gl-ES');
        }
        if (languaje === 'es') {
          setTarjetaPathLang('es-ES');
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataApp.lang]);
    return (
      <>
        <div className="bloque-tarjeta bloque-tarjeta__club">
          <p className="etiqueta">{t('tarjetas.tarjeta-socio.credit-card')}</p>
          <div className="bloque-tarjeta__contenido">
            <div className="img">
              <img
                src="../../assets/images/img-tarjeta.png"
                alt="Imagen tarjeta Club pasando de manos"
              />
            </div>

            <div className="bloque-tarjeta__content">
              <p className="title__medium u-margin-bottom-small">
                {t('tarjetas.tarjeta-socio.save-with-credit-card')}
              </p>
              <p className="u-margin-bottom-small">
                {t('tarjetas.tarjeta-socio.save-what')}
              </p>

              <ul className="lista-ventajas">
                <li className="lista-ventajas__item">
                  <div className="icon">
                    <IconDinero />
                  </div>
                  <span>{t('tarjetas.tarjeta-socio.cash')}</span>
                </li>
                <li className="lista-ventajas__item">
                  <div className="icon">
                    <IconPorcentaje classCss="fill-rojo-eroski" />
                  </div>
                  <span>{t('tarjetas.tarjeta-socio.shop-one-porcent')}</span>
                </li>
                <li className="lista-ventajas__item">
                  <div className="icon">
                    <IconTarjeta />
                  </div>
                  <span>{t('tarjetas.tarjeta-socio.card-advantages')}</span>
                </li>
              </ul>

              <div className="botonera">
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.location.href = `${
                      process.env.REACT_APP_SERVER_EROSKI_ES
                    }${t('link.info-tpec')}`;
                  }}
                  className="btn btn-secundary"
                >
                  {t('tarjetas.tarjeta-socio.more-info')}
                </button>
                <button
                  type="button"
                  onClick={solicitarTarjetaPago}
                  className="btn btn-primary"
                >
                  {t('tarjetas.tarjeta-socio.to-request')}
                </button>
              </div>
            </div>
          </div>
          <p className="legal">
            {t('tarjetas.tarjeta-socio.block-min-text-two')}
          </p>
        </div>
      </>
    );
  }
};

export default SolicitarInformacionTPEC;
